import { Component } from '@angular/core';

@Component({
  selector: 'ai-knowledge-loading-spinner',

  templateUrl: './ai-loading-spinner.component.html',
  styleUrls: ['./ai-loading-spinner.component.scss'],
})
export class AiLoadingSpinnerComponent {}
